import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";

// // // //

export const DISTRIBUTION_FREQUENCY_TYPE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "distribution_frequency_type",
    label: "Distribution Frequency",
    type: ColumnTypes.string,
    width: 175,
    render: (item) => {
        if (!item.isAsset) return null;

        const value = item.distribution_frequency_type;
        if (!value) return <Emdash />;

        return <span className="dg-overflow">{value}</span>;
    },
};
